var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_9",
    "data-name": "Layer 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.729,
    height: 20.062,
    viewBox: "0 0 26.729 20.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.081,
    y1: 0.937,
    x2: 0.832,
    y2: 0.167,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006f95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a8e1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.057,
    y1: -0.098,
    x2: 0.886,
    y2: 0.872,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M87.717.2,85.855,3.587h0L79.662,14.853l-.054.121-.3.526-.918,1.66h0l-.648,1.187a4.25,4.25,0,0,1-.621.823l-.175.162-.2.162a2.442,2.442,0,0,1-.391.256,4.129,4.129,0,0,1-.661.3,3.643,3.643,0,0,1-3.522-.688,3.9,3.9,0,0,1-.81-.985L70.5,16.864c.148-.445.31-.891.486-1.363A26.513,26.513,0,0,1,74.4,9.281h0a26.108,26.108,0,0,1,3-3.319h0l1.025-.891A24.543,24.543,0,0,1,87.717.2Z",
    transform: "translate(-60.988 -0.173)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M17.406,16.987h0l-.648,1.187a4.25,4.25,0,0,1-.621.823l-.175.162-.2.162a2.442,2.442,0,0,1-.391.256,4.129,4.129,0,0,1-.661.3,3.724,3.724,0,0,1-3.522-.688,3.9,3.9,0,0,1-.81-.985L8.743,15.328l-.5-.864h0L1.943,3.4,0,0A24.732,24.732,0,0,1,9.4,4.884c.351.3.688.594,1.012.9a24.22,24.22,0,0,1,3,3.319h0a25.569,25.569,0,0,1,3.414,6.22C17.055,15.894,17.244,16.448,17.406,16.987Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LogoIcon.e4e161163c86bb377a6473e41e23d558.svg";
export { ForwardRef as ReactComponent };